module.exports = __webpack_public_path__ + "img/zxitemimg1.50870911.png";